import { z } from 'zod';

// ============================================================
// Petty Cash Entry Schemas (Story 2.3)
// ============================================================

const isNotFuture = (date: Date) => date <= new Date();

export const createPettyCashSchema = z.object({
  date: z
    .string()
    .datetime({ offset: true })
    .or(z.string().date())
    .transform((val) => new Date(val))
    .refine(isNotFuture, { message: 'Date cannot be in the future' }),
  description: z.string().min(1, 'Description is required').max(500),
  amount: z
    .number()
    .positive('Amount must be greater than 0')
    .max(999999.99, 'Amount is too large'),
  categoryId: z.string().uuid('Invalid category'),
  clientLocalId: z.string().uuid().optional(),
});

export type CreatePettyCashInput = z.input<typeof createPettyCashSchema>;

export const updatePettyCashSchema = createPettyCashSchema.partial();
export type UpdatePettyCashInput = z.input<typeof updatePettyCashSchema>;

export const pettyCashResponseSchema = z.object({
  id: z.string(),
  claimId: z.string(),
  date: z.date().or(z.string()),
  description: z.string(),
  amount: z.union([z.number(), z.string()]),
  categoryId: z.string(),
  category: z.object({ id: z.string(), name: z.string() }).optional(),
  receipts: z.array(z.object({ id: z.string(), filename: z.string(), size: z.number() })).optional(),
  // Issue #12 (A6) Verification fields
  adminVerified: z.boolean().default(false),
  adminVerifiedById: z.string().nullable().optional(),
  adminVerifiedAt: z.date().or(z.string()).nullable().optional(),
  financeVerified: z.boolean().default(false),
  financeVerifiedById: z.string().nullable().optional(),
  financeVerifiedAt: z.date().or(z.string()).nullable().optional(),
  hrVerified: z.boolean().default(false),
  hrVerifiedById: z.string().nullable().optional(),
  hrVerifiedAt: z.date().or(z.string()).nullable().optional(),
  flagReason: z.string().nullable().optional(),
  flaggedById: z.string().nullable().optional(),
  flaggedAt: z.date().or(z.string()).nullable().optional(),
  createdAt: z.date().or(z.string()),
  updatedAt: z.date().or(z.string()),
});

export type PettyCashResponse = z.infer<typeof pettyCashResponseSchema>;
